
export const checkPdfReport = file => async dispatch => { 
  dispatch({ type: "CHECK_REPORT_START" });

  file = file[0];
  var formData = new FormData();
  formData.append("files", file);
  
  const res = await fetch(
    process.env.REACT_APP_API_URL + "/api/file-hashes/check",
    {
      method: "POST",
      credentials: "include",
      body: formData
    }
  )
    .then(async function (response) {
      const result = await response.json();
      return result;
    })
    .then(function (body) {
      return body;
    });

  if (res.foundHash) {
    dispatch({
      type: "CHECK_REPORT_SUCCESS",
      payload: res.dataReport
    });
  } else {
    dispatch({ type: "CHECK_REPORT_FAIL" });
  }
};

export const resetCheckPdfReport = () => async dispatch => { 
  dispatch({ type: "RESET_CHECK_REPORT" });
};


// WEBPACK FOOTER //
// ./src/actions/ReportsActions.js